/**
 * @generated SignedSource<<5017fd5e8151cd34223633ef14962282>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewMobile_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenAttendCard_query" | "EventScreenJoin_query" | "SponsorsSection_query">;
  readonly " $fragmentType": "EventScreenNewMobile_query";
};
export type EventScreenNewMobile_query$key = {
  readonly " $data"?: EventScreenNewMobile_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewMobile_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewMobile_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SponsorsSection_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "58ea352ddbf634ca04bd23db855ccc15";

export default node;
